import classNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'

import * as styles from './SplitSection.module.scss'
import TextLogo from '../../../assets/new-icons/text_logo_small.svg'
import ButtonWithLinkGroup from '../../button-with-link-group/ButtonWithLinkGroup'

function SplitSection({
  className,
  subTitle,
  title,
  text,
  linkText,
  linkPath,
  isExternal,
  isTargetBlank,
  buttonText,
  linkButtonPath,
  getBambooButton,
  handleButtonPress,
  renderedImage,
  renderedImageOverlay,
  renderedImageOverlayClass,
  subHeading,
  comingSoon,
  newFeature,
  greyBackground,
  imageRight = false,
  headingDisplay2,
  isBambooLogo,
  backgroundColor,
  withSubImage,
  shadowed,
  ...rest
}) {
  return (
    <section
      style={{ backgroundColor }}
      className={classNames(
        styles.splitSection,
        greyBackground && styles.greyBackground,
        className
      )}
      {...rest}
    >
      <div
        className={classNames(
          styles.container,
          withSubImage && styles.withSubImage
        )}
      >
        {renderedImage && (
          <div
            className={classNames(
              styles.imageContainer,
              imageRight && styles.imageRight
            )}
          >
            <div
              className={classNames(
                styles.imageWrap,
                withSubImage && styles.subImageWrapp
              )}
            >
              {renderedImage}
            </div>
            {renderedImageOverlay && (
              <div
                className={classNames(
                  styles.imageOverlay,
                  renderedImageOverlayClass
                )}
              >
                {renderedImageOverlay}
              </div>
            )}
          </div>
        )}

        <div className={styles.contentWrap}>
          {isBambooLogo && (
            <img
              className={styles.bambooLogo}
              src={TextLogo}
              width="120px"
              height="22px"
              alt="Bamboo investments App"
            />
          )}

          {subTitle && (
            <strong className={styles.subTitle}>
              {subTitle} {newFeature && <span> NEW </span>}
            </strong>
          )}

          {title && (
            <h2
              className={classNames(
                styles.title,
                headingDisplay2 && styles.display2
              )}
            >
              {title}
            </h2>
          )}

          {subHeading && <div className={styles.subHeading}>{subHeading}</div>}

          {text && <div className={styles.text}>{text}</div>}

          {comingSoon ? (
            <span>Coming Soon</span>
          ) : (
            ((linkText && linkPath) || buttonText || getBambooButton) && (
              <ButtonWithLinkGroup
                className={styles.buttonsWrapp}
                {...{
                  linkText,
                  buttonText,
                  linkButtonPath,
                  linkPath,
                  handleButtonPress,
                  getBambooButton,
                  isExternal,
                  isTargetBlank,
                  shadowed,
                }}
              />
            )
          )}
        </div>
      </div>
    </section>
  )
}

SplitSection.propTypes = {
  className: PropTypes.string,
  subTitle: PropTypes.string,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  buttonText: PropTypes.string,
  linkButtonPath: PropTypes.string,
  linkText: PropTypes.string,
  linkPath: PropTypes.string,
  backgroundColor: PropTypes.string,
  getBambooButton: PropTypes.bool,
  handleButtonPress: PropTypes.func,
  renderedImage: PropTypes.element,
  imageRight: PropTypes.bool,
  comingSoon: PropTypes.bool,
  newFeature: PropTypes.bool,
  greyBackground: PropTypes.bool,
  headingDisplay2: PropTypes.bool,
  subHeading: PropTypes.string,
  isExternal: PropTypes.bool,
  isTargetBlank: PropTypes.bool,
  isBambooLogo: PropTypes.bool,
  withSubImage: PropTypes.bool,
  shadowed: PropTypes.bool,
}

export default SplitSection
